import React, {useRef, useEffect} from 'react';
import styles from './styles.module.css';

const InteractivePlayVideo = ({src, width = 400}) => {
  const videoRef = useRef(null);
  const scrollTimeoutRef = useRef(null);

  const playVideo = () => {
    const video = videoRef.current;
    if (video && video.paused) {
      video.loop = true;
      video.currentTime = 0;
      video.play().catch((err) => console.warn(err));
    }
  };

  const stopLoop = () => {
    const video = videoRef.current;
    if (video) video.loop = false;
  };

  useEffect(() => {
    const handleScroll = () => {
      playVideo();
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = setTimeout(() => {
        stopLoop();
      }, 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeoutRef.current);
    };
  }, []);

  return (
    <video
      className={styles.liveProfile}
      ref={videoRef}
      src={src}
      autoPlay
      muted
      playsInline
      onMouseEnter={playVideo}
      onMouseLeave={stopLoop}
    />
  );
};

export default InteractivePlayVideo;
